import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import { forwardRef } from "react";

import { GaiaDropdownOptions } from "../../types/appTypes";

type Props = {
    options: GaiaDropdownOptions[];
    disabled?: boolean;
} & TextFieldProps;

const GaiaOptionsDropdown = forwardRef<HTMLDivElement, Props>(({ options, disabled, ...textFieldProps }, ref) => {
    return (
        <TextField ref={ref} {...textFieldProps} select disabled={disabled}>
            {options ? (
                options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))
            ) : (
                <MenuItem />
            )}
        </TextField>
    );
});

export default GaiaOptionsDropdown;
